import _ from 'lodash';
import { observe, generate, deepClone, compare } from 'fast-json-patch';

export default class JSONPatchUtils {
    static getJSONPatch = (document, actions) => {
        const clonedDocument = deepClone(document);
        const observer = observe(clonedDocument);
        actions.forEach(({ keyPath, value }) => {
            _.set(clonedDocument, keyPath, value);
        });
        return generate(observer);
    };

    static diff(obj1, obj2) {
        JSONPatchUtils.clean(obj1);
        JSONPatchUtils.clean(obj2);
        return compare(obj1, obj2);
    }

    /**
     * Delete all null (or undefined) properties from an object.
     * Set 'recurse' to false if you dont want to delete properties in nested objects.
     */
    static clean(test, recurse = true) {
        for (var i in test) {
            if (test[i] === null) {
                delete test[i];
            } else if (recurse && typeof test[i] === 'object') {
                JSONPatchUtils.clean(test[i], recurse);
            }
        }
    }
}
